import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'OD',
    name: 'Prophète aux Trois Trépas',
    id: 'ThriceDeadProphet',
    health: 40,
    difficulty: 5,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'OD',
    name: 'Maître des Spectres',
    id: 'Wraithmonger',
    health: 70,
    difficulty: 6,
    expeditionRating: 4,
    additionalInfo: '',
  },
]
